var en_US = {};
module['exports'] = en_US;
en_US.title = "English (United States)";
en_US.internet = require("./internet");
en_US.address = require("./address");
en_US.phone_number = require("./phone_number");